import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    Container, Row, Col, Card, CardHeader, CardBody,
    Table, Input, FormGroup, Label, Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import UiContent from '../../../Components/Common/UiContent';
import BetterStandsContext from '../../../Components/Contexts/Management/BetterStandsContext';
import UygunsuzlukDetailModal from '../../../Components/Saha/UygunsuzlukDetailModal';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const FORM_TYPES = [
    { label: 'ISG',             value: 4 },
    { get label() { return i18n.t("saha:uygunsuzlukDetayIndex.elektrik"); },        value: 1 },
    { get label() { return i18n.t("saha:uygunsuzlukDetayIndex.acilDurum"); },      value: 5 },
    { get label() { return i18n.t("saha:uygunsuzlukDetayIndex.n24SaatElektrik"); },value: 3 },
    { get label() { return i18n.t("saha:uygunsuzlukDetayIndex.lojistik"); },        value: 9 },
    { get label() { return i18n.t("saha:uygunsuzlukDetayIndex.isIzni"); },         value: 8 },
];

const tableStyles = {
    tableResponsive: { overflowX: 'auto', width: '100%' },
    table: { width: '100%' },
    cell: { wordBreak: 'break-word', maxWidth: '200px' },
};

const UygunsuzlukDetay = () => {
  const { t } = useTranslation("saha");
    const { fetchActiveFairId, activeFairId } = useContext(BetterStandsContext);
    const [selectedFormType, setSelectedFormType] = useState(FORM_TYPES[0]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [uyumsuzluklar, setUyumsuzluklar] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUyumsuzluk, setSelectedUyumsuzluk] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => { document.title = i18n.t("saha:uygunsuzlukDetayIndex.uygunsuzlukDetayFormlariFds"); }, []);

    const fetchUyumsuzluklar = async () => {
        setLoading(true);
        try {
            const payload = {
                fuar_id: activeFairId,
                start: 0,
                length: 1000,
                search: { value: searchTerm, regex: false },
                form_level_id: 3,
                form_type_id: selectedFormType.value,
                form_salon_id: 0,
                draw: 1,
                columns: Array(10).fill({
                    data: 0, name: null, searchable: true, orderable: true,
                    search: { value: null, regex: false },
                }),
                order: [{ column: 8, dir: 'desc' }],
            };
            const res = await axios.post(
                'https://fds.sakagrup.com/FormSystem/xFormListeBS/3',
                payload,
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }
            );
            setUyumsuzluklar(res.data.data || []);
        } catch (err) {
            console.error('Uygunsuzluklar yüklenemedi:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const init = async () => {
            const userId = localStorage.getItem('userId');
            if (userId) await fetchActiveFairId(userId);
        };
        init();
    }, [fetchActiveFairId]);

    useEffect(() => {
        if (activeFairId) {
            async function run() { await fetchUyumsuzluklar(); } run();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFairId, selectedFormType, searchTerm]);

    const openDetail = (u) => { setSelectedUyumsuzluk(u); setModalOpen(true); };
    const closeDetail = () => { setSelectedUyumsuzluk(null); setModalOpen(false); };

    const handleDeleteConfirm = async () => {
        if (!selectedUyumsuzluk) return;
        setDeleteLoading(true);
        try {
            await axios.delete(`https://fds.sakagrup.com/Saha/xDeleteUyumsuzluk/${selectedUyumsuzluk[0]}`);
            setDeleteConfirmOpen(false);
            closeDetail();
            fetchUyumsuzluklar();
        } catch (err) {
            console.error('Silme hatası:', err);
            alert(t("uygunsuzlukDetayIndex.uygunsuzlukSilinirkenHataOlustu"));
        } finally {
            setDeleteLoading(false);
        }
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("uygunsuzlukDetayIndex.uygunsuzlukDetayFormlari")} pageTitle={t("uygunsuzlukDetayIndex.sahaFormlari")} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">{t("uygunsuzlukDetayIndex.uygunsuzlukDetayFormlari")}</h4>
                                </CardHeader>
                                <CardBody>
                                    <Row className="g-3 mb-3 align-items-end">
                                        <Col sm="auto">
                                            <FormGroup className="mb-0">
                                                <Label>{t("uygunsuzlukDetayIndex.formTipi")}</Label>
                                                <Input
                                                    type="select"
                                                    value={selectedFormType.value}
                                                    onChange={e => {
                                                        const ft = FORM_TYPES.find(f => f.value === parseInt(e.target.value));
                                                        setSelectedFormType(ft);
                                                    }}
                                                >
                                                    {FORM_TYPES.map(ft => (
                                                        <option key={ft.value} value={ft.value}>{ft.label}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col sm>
                                            <FormGroup className="mb-0">
                                                <Label>{t("common:ara")}</Label>
                                                <Input
                                                    type="text"
                                                    value={searchTerm}
                                                    onChange={e => setSearchTerm(e.target.value)}
                                                    placeholder={t("uygunsuzlukDetayIndex.ara")}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {loading ? (
                                        <p>{t("common:yukleniyor")}</p>
                                    ) : uyumsuzluklar.length === 0 ? (
                                        <p>{t("uygunsuzlukDetayIndex.uygunsuzlukKaydiBulunamadi")}</p>
                                    ) : (
                                        <div style={tableStyles.tableResponsive}>
                                            <Table className="table align-middle table-nowrap" style={tableStyles.table}>
                                                <thead>
                                                    <tr>
                                                        <th>{t("uygunsuzlukDetayIndex.id")}</th>
                                                        <th>{t("uygunsuzlukDetayIndex.uygunsuzluk")}</th>
                                                        <th>{t("uygunsuzlukDetayIndex.stant")}</th>
                                                        <th>{t("uygunsuzlukDetayIndex.denetmen")}</th>
                                                        <th>{t("uygunsuzlukDetayIndex.islem")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {uyumsuzluklar.map(u => (
                                                        <tr key={u[0]}>
                                                            <td style={tableStyles.cell}>{u[0]}</td>
                                                            <td style={tableStyles.cell}>
                                                                <div>{u[5]}</div>
                                                                <div>{u[2]} / {u[3]}</div>
                                                                <div>{u[4]}</div>
                                                            </td>
                                                            <td style={tableStyles.cell}>{u[6]}</td>
                                                            <td style={tableStyles.cell}>{u[7]}<br />{u[8]}</td>
                                                            <td style={tableStyles.cell}>
                                                                <Button color="warning" onClick={() => openDetail(u)}>
                                                                    {t("common:detay")}
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <UygunsuzlukDetailModal
                isOpen={modalOpen}
                toggle={closeDetail}
                selectedUyumsuzluk={selectedUyumsuzluk}
                formTypeId={selectedFormType.value}
                activeFairId={activeFairId}
                onDelete={() => { fetchUyumsuzluklar(); closeDetail(); }}
            />

            <Modal isOpen={deleteConfirmOpen} toggle={() => setDeleteConfirmOpen(false)} centered>
                <ModalHeader toggle={() => setDeleteConfirmOpen(false)}>{t("uygunsuzlukDetayIndex.silmeOnayi")}</ModalHeader>
                <ModalBody>{t("uygunsuzlukDetayIndex.buUygunsuzlukKaydiniSilmekIstediginizden")}</ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setDeleteConfirmOpen(false)} disabled={deleteLoading}>{t("common:iptal")}</Button>
                    <Button color="danger" onClick={handleDeleteConfirm} disabled={deleteLoading}>
                        {deleteLoading ? t("uygunsuzlukDetayIndex.siliniyor") : t("uygunsuzlukDetayIndex.evetSil")}
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default UygunsuzlukDetay;

